import { useQuery } from '@apollo/client';
import { createContext, useMemo, useState } from 'react';
import { ORDER_STATUS_OPTIONS, REPORTS } from './constants';
import { useReportCallbacks } from './hooks';
import { MARKETPLACE_ORDERS_SHIPPERS } from './queries';

export const Context = createContext();

export const ContextProvider = ({ children }) => {
    const [reportType, setReportType] = useState(null);
    const [parameters, setParameters] = useState({});
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState({});
    const [notification, setNotification] = useState({});

    const report = useMemo(() => {
        return REPORTS[reportType];
    }, [reportType, REPORTS]);

    const isValid = useMemo(() => {
        return (
            !!report &&
            (report.parameters || []).every((parameter) => !parameter.required || !!parameters[parameter.key])
        );
    }, [report, parameters]);

    const { data: shippersData } = useQuery(MARKETPLACE_ORDERS_SHIPPERS);

    const shipperOptions = useMemo(() => {
        return (shippersData?.orders || [])
            .map((o) => ({ value: o.order_shipper.client_id, label: o.order_shipper.business_name }))
            .sort((a, b) => a.label.localeCompare(b.label));
    }, [shippersData]);

    const callbacks = useReportCallbacks(
        { reportType, report, parameters, data },
        { setData, setLoading, setNotification }
    );

    return (
        <Context.Provider
            value={{
                state: {
                    reportType,
                    report,
                    parameters,
                    data,
                    notification,
                    isValid,
                    options: {
                        shipper_id: shipperOptions,
                        order_status: ORDER_STATUS_OPTIONS,
                    },
                },
                loading,
                callbacks: {
                    ...callbacks,
                    setNotification,
                    selectReport: (reportType) => {
                        setReportType(reportType);
                        setData([]);
                        setParameters({});
                    },
                    selectParameter: (key, value) => {
                        setParameters((prev) => ({ ...prev, [key]: value }));
                    },
                },
            }}
        >
            {children}
        </Context.Provider>
    );
};
